import Menu from '../../../components/Menu';
import { useEffect, useState } from 'react';
import Topo from '../../../components/Topo';
import api from '../../../services/api';
import moment from 'moment';

function removeMask(str) {
	str = str.replaceAll('.', '');
	str = str.replaceAll('-', '');
	str = str.replaceAll(' ', '');
	str = str.replaceAll('_', '');
	return str;
}
const DadosLayout = ({ dados }) => {
	return (
		<div class="container" style={{ marginBottom: '8%;' }}>
			<form style={{ marginTop: '0', paddingTop: '0' }}>
				<div class="col-md-12">

					<div class="tab-content" id="PesquisaResult">
						<div role="tabpanel" class="tab-pane active" id="home">
							<div class="table-responsive">
								<table id="result" class="table table-bordred table-striped">
									<thead>
										<tr>
											<th>CPF/CNPJ</th>
											<th>Nome / Razão Social</th>
											<th>Nascimento</th>
											<th>Cidade</th>
											<th>UF</th>
										</tr>
									</thead>
									<tbody>
										{dados.map((dado) => {
											return <tr>
												<td><a target='_blank' href={`./Resultado/${removeMask(dado.CPF)}`}>{dado.CPF}</a></td>
												<td>{dado.NOME}</td>
												<td>{moment(dado.NASC).format("DD/MM/YYYY")} {dado.IDADE ? ` (${dado.IDADE} anos)` : ''} </td>
												<td>{dado.CIDADE ? dado.CIDADE : '-'}</td>
												<td>{dado.UF ? dado.UF : '-'}</td>
											</tr>
										})}
									</tbody>
								</table>

							</div>

							<div class="pagnatin">
								<div class="clearfix"></div>


							</div>
						</div>
						<input type="hidden" value="" name="paginas" id="paginas" />
					</div>
				</div>
			</form></div>
	);
}

function Painel() {
	const [trava, setTrava] = useState(true);
	const [dadosUsuarios, setDadosUsuarios] = useState([]);
	const [dadosHistorico, setDadosHistorico] = useState([]);
	const [dadosOnline, setDadosOnline] = useState([]);
	
	const [dadosFaturas, setDadosFaturas] = useState([]);
	
	const [loading, setLoging] = useState(false);
	const [toggleState, setToggleState] = useState(8);
	var [doc, setDoc] = useState('');
	const [nome, setNome] = useState('');
	const [telefone, setTelefone] = useState('');
	const [cidade, setCidade] = useState('');
	const [uf, setUf] = useState('');
	const [numero, setNumero] = useState('');
	const [logradouro, setLogradouro] = useState('');

	const [numeroInicial, setNumeroInicial] = useState('');
	const [numeroFinal, setNumeroFinal] = useState('');

	const [cep, setCep] = useState('');
	const [email, setEmail] = useState('');
	var [placa, setPlaca] = useState('');
	const [dados, setDados] = useState([]);
	const [dadosPlaca, setDadosPlaca] = useState({});
	const [msg, setMsg] = useState('');
	const [listaDados, setListaDados] = useState([]);
	const toggleTab = (index) => {
		setToggleState(index);
		setDados([])
		setMsg('');
		setDadosPlaca({});

	};


	const handleDeslogar = async (id) => {
		try {
			var dados = await api.get("/adm/deslogar/"+id);
			alert(dados.data.msg ?? '');
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}
		return;
	};

	const submitDoc = (e) => {
		e.preventDefault(0);
		console.log(doc);
		setLoging(true);
		if (doc.length > 0) {
			doc = doc.replace('-', '').replace('.', '').replace('.', '')
			window.location = './Resultado/' + doc;
			return;
		} else {
			setMsg('Digite um documento valido.');
		}
	};

	const submitNome = async (e) => {
		e.preventDefault(0);
		setLoging(true);
		setMsg('Aguarde....');
		setDados({});
		setDadosPlaca({});
		try {
			var dados = await api.post("/api/nome", { nome: nome, cidade: cidade, uf: uf });
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}
		if (dados.data.msg) {
			setMsg(dados.data.msg);
			//			alert(dados.data.msg);
		}
		if (nome.length > 3) {
			if (dados.data.msg) {
				setMsg(dados.data.msg);
			} else {
				setMsg('');
				setDados(dados.data);

				setListaDados(dados.data);
			}
		} else {
			setDados({});
			setDadosPlaca({});
			setListaDados([]);

			setMsg('Digite um nome valido.');
		}
	};

	const submitTelefone = async (e) => {
		e.preventDefault(0);
		setLoging(true);
		setMsg('Aguarde....');
		setDados({});
		setDadosPlaca({});
		try {
			var dados = await api.post("/api/telefone", { telefone: telefone });
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}

		if (telefone.length > 3) {
			if (dados.data.msg) {
				setMsg(dados.data.msg);
			} else {
				setMsg('');
				setDados(dados.data);
			}
		} else {
			setDados({});
			setDadosPlaca({});

			setMsg('Digite um telefone valido.');
		}
	};

	const submitEndereco = async (e) => {
		e.preventDefault(0);
		setLoging(true);
		setMsg('Aguarde....');
		setDados({});
		setDadosPlaca({});

		try {
			var dados = await api.post("/api/endereco", { numeroInicial: numeroInicial, numeroFinal: numeroFinal, logradouro: logradouro, cidade: cidade, uf: uf });
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}
		if (dados.data.msg) {
			setMsg(dados.data.msg);
		} else {
			setMsg('');
			setDados(dados.data);
		}
		// 		if(cep.length > 3){
		// 			if(dados.data.msg){
		// 				setMsg(dados.data.msg);				
		// 			}else{
		// 				setMsg('');
		// 				setDados(dados.data);
		// 			}
		// 		}else{
		// 			setDados({});
		// 			setDadosPlaca({});
		// 
		// 			setMsg('Digite um cep valido.');
		// 		}
	};

	const submitEmail = async (e) => {
		e.preventDefault(0);
		setLoging(true);
		setMsg('Aguarde....');
		setDados({});
		setDadosPlaca({});

		try {
			var dados = await api.post("/api/email", { email: email });
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}

		if (email.length > 3) {
			if (dados.data.msg) {
				setMsg(dados.data.msg);
			} else {
				setMsg('');
				setDados(dados.data);
			}
		} else {
			setDados({});
			setDadosPlaca({});

			setMsg('Digite um email valido.');
		}
	};

	const submitPlaca = (e) => {
		e.preventDefault(0);
		setLoging(true);
		if (placa.length > 0) {
			placa = placa.replace('-', '').replace('.', '').replace('.', '')
			window.location = './Placa/' + placa;
			return;
		} else {
			setMsg('Digite uma placa valido.');
		}
	};

	function converterData(dataString) {
		const partes = dataString.split('/');
		// new Date(ano, mês, dia) - No JavaScript, os meses são baseados em zero, então é necessário subtrair 1 do mês
		return new Date(partes[2], partes[1] - 1, partes[0]);
	}
// 

	useEffect(() => {
		
//		console.log(( dadosUsuarios), 'lista no effect');


		const parseDate = (dateStr) => {
			const [day, month, year] = dateStr.split('/').map(Number);
			return new Date(year, month - 1, day); // O mês é 0-indexado em JavaScript
		};

		const isDateEqualOrAfterToday2 = (targetDateStr) => {
			const currentDate = moment().startOf('day'); // Data atual com hora zerada
			const targetDate = moment(targetDateStr, 'DD/MM/YYYY').startOf('day'); // Data fornecida com hora zerada

			// Verificar se a data fornecida é igual ou posterior à data atual
			return targetDate.isSameOrAfter(currentDate);
		};

		const isDateEqualOrAfterToday = (targetDateStr) => {

			// Data no formato "dd/mm/YYYY"
			const dataOriginal = targetDateStr;

			// Converter para objeto Date
			const dataConvertida = converterData(dataOriginal);

			// Data atual
			const dataAtual = new Date();

			// Comparar se a data convertida é menor que a data atual
			if (dataConvertida < dataAtual) {
				return 'vencido'
			} else if (dataConvertida.getTime() === dataAtual.getTime()) {
				return 'vencido';
				//				console.log('A data convertida é igual à data atual.');
			} else {
				return 'ativo';
				//					console.log('A data convertida é posterior à data atual.');
			}
		};


		const findDadosPerfil = async () => {
			try {
				var dados = await api.get("/perfil");
				//	console.log(dados.data);

				const datevencimento = isDateEqualOrAfterToday(dados.data.vencimento);
				console.log(datevencimento);
				if (datevencimento === 'vencido') {
					window.location.href = '/Perfil?msg=cadastro vencido, pague a fatura pendente para continuar...';
					return;
				}
			} catch (e) {
				var dados = '';
				setLoging(0);
				setMsg('Indisponivel no momento.');
			}
		}
		findDadosPerfil();


		const checkAdm = async () => {
			try {
				var dados = await api.get("/checkAdm");
				//	console.log(dados.data);

				if (dados.data.status != 'true') {
					window.location.href = '/Sair';
					return;
				} else {
					setTrava(false);
				}
			} catch (e) {
				var dados = '';
				setLoging(0);
				setMsg('Indisponivel no momento.');
				setTimeout(() => {
					window.location.href = '/Sair';
					return;
				}, 600);
			}
		}
		checkAdm();

	}, [listaDados]);


	useEffect(() => {



	

		async function addDads() {
			

			try {
				var dados = await api.get("/adm/historico");
				//	console.log(dados.data);

			
					setDadosHistorico(dados.data);
				//	setTrava(false);
			} catch (e) {
				
			}

		

		// setDadosFaturas([
		// 	{
		// 		id: 1,
		// 		usuario: 'demonew',
		// 		tipo: 1,
		// 		periodo: 30,
		// 		valor: '69.99',
		// 		id_transacao: '7155831781044a7da8f26d7f49f958f1',
		// 		data_pg: '2024-05-20 22:12:22',
		// 		status: 2
		// 	}
		// ]);
	}

	setTimeout(() => {
		addDads();

	}, 300);

	setTimeout(() => {
		console.log(dadosUsuarios)

	}, 800);

	}, []);

	const handleEditarFatura = (event, id) => {
		//alert('ok')
		return window.location.href="../../Adm/Faturas/"+id;
	};
	return (
		<>
			<section>
				<Menu />


				<div class="main-content" style={{ marginLeft: '0' }}>
					<div id="page-wrapper">
						<div class="container">
							<Topo />
							<br />
							{trava == false ? <div class="container">
								<div class="col-md-12">
									<div class="card">
										<ul class="nav nav-tabs" role="tablist">
											<li role="presentation" class={toggleState === 1 ? 'active' : ''} onClick={() => window.location.href='../../../Adm/Usuarios'}>
												<a href="#" aria-controls="documento" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-users"></i>&nbsp;
													<span>Usuários</span>
												</a>
											</li>
											<li role="presentation" class={toggleState === 8 ? 'active' : ''} onClick={() => window.location.href='../../../Adm/Historico'}>
												<a href="#" aria-controls="documento" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-search" style={{color: '#fff'}}></i>&nbsp;
													<span>Historico</span>
												</a>
											</li>
											<li role="presentation" class={toggleState === 2 ? 'active' : ''} onClick={() => window.location.href='../../../Adm/Faturas'}>
												<a href="#" aria-controls="nome" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-list" aria-hidden="true"></i>
													
													<span>Faturas</span>
												</a>
											</li>
											<li role="presentation" class={toggleState === 3 ? 'active' : ''} onClick={() => window.location.href='../../../Adm/Online'}>
												<a href="#" aria-controls="telefone" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-wifi"></i>
													<span>Online</span>
												</a>
											</li>
											
											<li role="presentation" class={toggleState === 5 ? 'active' : ''}>
												<a href="../../../Sair" aria-controls="email" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-times" aria-hidden="true"></i>
													<span>Sair</span>
												</a>
											</li>
											{/* <li role="presentation" class={toggleState === 6 ? 'active' : ''} onClick={()=> toggleTab(6)}>
											<a href="#" aria-controls="email" role="tab" data-toggle="tab" class="bntmenu">
												<i class="fa fa-taxi" aria-hidden="true"></i>
												<span>Veiculo</span>
											</a>
										</li> */}
										</ul>
										<div class="tab-content">

											<div role="tabpanel" class={toggleState === 1 ? 'tab-pane active' : 'tab-pane'} id="documento">
												<form onSubmit={submitDoc} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="Pesquisar usuário" name="doc" id="doc" value={doc} onChange={(e) => setDoc(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="button" id="pes_doc" onClick={submitDoc}>
																	<span class="glyphicon glyphicon-search"></span>
																</button>
															</span>

														</div>

													</div>

												</form>


		<div class="container" style={{ marginBottom: '8%;' }}>
			<form style={{ marginTop: '0', paddingTop: '0' }}>
				<div class="col-md-12">

					<div class="tab-content" id="PesquisaResult">
						<div role="tabpanel" class="tab-pane active" id="home">
							<div class="table-responsive">
								<table id="result" class="table table-bordred table-striped">
									<thead>
										<tr>
										<th>ID</th>
											<th>Usuário</th>
											<th>DOC</th>
											<th>Nome</th>
											<th>E-mail</th>
											<th>Telefone</th>
											<th>Contratação</th>
											<th>Vencimento</th>
											<th>Status</th>
											<th>OPÇÕES</th>
										</tr>
									</thead>
									<tbody>
										{dadosUsuarios ? (dadosUsuarios).map((dado) => {
											
											return (<tr>
												<td><a target='_blank' href={`./Resultado/${(dado.id)}`}>#{dado.id}</a></td>
												<td>{dado.usuario}</td>
												<td>{dado.doc}</td>
												<td>{dado.nome}</td>
												<td>{dado.email}</td>
												<td>{dado.telefone}</td>

												<td>{moment(dado.contratacao).format("DD/MM/YYYY") }</td>
												<td>{moment(dado.vencimento).format("DD/MM/YYYY") }</td>

												<td>
												{dado.status == '1' ? 'Ativo' : ''}
												{dado.status == '2' ? 'Inativo' : ''}
												{dado.status == '8' ? <span style={{fontWeight: 'bold'}}>ADM</span> : ''}
												</td>
												<td style={{display: 'flex', justifyContent: 'space-evenly', gap: '5px'}}>
												<button className='btn btn-secundary' style={{height: '25px', paddingTop: '2px', background: '#187164', color: '#fff'}}>
												
													<i className="fa fa-list-alt"></i>
														</button>

												<button className='btn btn-secundary' style={{height: '25px', paddingTop: '2px', background: '#187164', color: '#fff'}}>
												
													<i className="fa fa-usd"></i>
														</button>
												<button className='btn btn-secundary' style={{height: '25px', paddingTop: '2px', background: '#3559e4', color: '#fff'}}>
												<i className="fa fa-pencil"></i>
												</button>
												<button className='btn btn-primary' style={{height: '25px', paddingTop: '2px'}}>
												<i className="fa fa-times"></i>
												</button>
												</td>
											</tr>)
										}) : <></>}
									</tbody>
								</table>

							</div>

							<div class="pagnatin">
								<div class="clearfix"></div>


							</div>
						</div>
						<input type="hidden" value="" name="paginas" id="paginas" />
					</div>
				</div>
			</form></div>

											</div>


											<div role="tabpanel" class={toggleState === 8 ? 'tab-pane active' : 'tab-pane'} id="historico">
												<form onSubmit={submitDoc} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="Pesquisar usuário" name="doc" id="doc" value={doc} onChange={(e) => setDoc(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="button" id="pes_doc" onClick={submitDoc}>
																	<span class="glyphicon glyphicon-search"></span>
																</button>
															</span>

														</div>

													</div>

												</form>


		<div class="container" style={{ marginBottom: '8%;' }}>
			<form style={{ marginTop: '0', paddingTop: '0' }}>
				<div class="col-md-12">

					<div class="tab-content" id="PesquisaResult">
						<span>Ultimas 100 consultas</span>
						<div role="tabpanel" class="tab-pane active" id="home">
							<div class="table-responsive">
								<table id="result" class="table table-bordred table-striped">
									<thead>
										<tr>
										<th>ID</th>
											<th>Usuário</th>
											<th>Serviço</th>
											<th>String</th>
											<th>Data</th>
											<th>Status</th>
											<th>OPÇÕES</th>
										</tr>
									</thead>
									<tbody>
										{dadosHistorico ? (dadosHistorico).map((dado) => {
											
											return (<tr>
												<td><a target='_blank' href={`./Adm/Historico/${(dado.id)}`}>#{dado.id}</a></td>
												<td>{dado.usuario}</td>
												<td>
													{dado.servico == 1 ? `CPF`: ``}
													{dado.servico == 2 ? `Nome`: ``}
													{dado.servico == 3 ? `Telefone/Email`: ``}
													{dado.servico == 4 ? `Endereço`: ``}

													
												</td>
												<td>
													<input type="text" value={dado.string}/>
												</td>
												<td>{moment(dado.data).format("DD/MM/YYYY HH:mm:ss") }</td>
												<td>{dado.status}</td>
												<td style={{display: 'flex', justifyContent: 'space-evenly', gap: '5px'}}>
												<button className='btn btn-secundary' style={{height: '25px', paddingTop: '2px', background: '#187164', color: '#fff'}}>
												
													<i className="fa fa-eye"></i>
														</button>

												
												</td>
											</tr>)
										}) : <></>}
									</tbody>
								</table>

							</div>

							<div class="pagnatin">
								<div class="clearfix"></div>


							</div>
						</div>
						<input type="hidden" value="" name="paginas" id="paginas" />
					</div>
				</div>
			</form></div>

											</div>


											<div role="tabpanel" class={toggleState === 2 ? 'tab-pane active' : 'tab-pane'} id="documento">
												<form onSubmit={submitDoc} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="Pesquisar usuário" name="doc" id="doc" value={doc} onChange={(e) => setDoc(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="button" id="pes_doc" onClick={submitDoc}>
																	<span class="glyphicon glyphicon-search"></span>
																</button>
															</span>

														</div>

													</div>

												</form>


		<div class="container" style={{ marginBottom: '8%;' }}>
			<form style={{ marginTop: '0', paddingTop: '0' }}>
				<div class="col-md-12">

					<div class="tab-content" id="PesquisaResult">
						<div role="tabpanel" class="tab-pane active" id="home">
							<div class="table-responsive">
								<table id="result" class="table table-bordred table-striped">
									<thead>
										<tr>
										<th>ID</th>
											<th>Usuário</th>
											<th>Tipo</th>
											<th>Periodo</th>
											<th>Valor</th>
											<th>ID Transação</th>
											<th>Data Pag</th>
											<th>Status</th>
											<th>OPÇÕES</th>
										</tr>
									</thead>
									<tbody>
										{dadosFaturas ? (dadosFaturas).map((dado) => {
											
											return (<tr>
												<td><a target='_blank' href={`./Resultado/${(dado.id)}`}>#{dado.id}</a></td>
												<td>{dado.usuario}</td>
												<td>
													{dado.tipo == '1' ? 'Contratação' : 'Renovação'}
												</td>
												<td>{dado.periodo}</td>
												<td>R$ {dado.valor}</td>
												<td><input type="text" value={dado.id_transacao}/></td>
												<td>{moment(dado.data_pg).format("DD/MM/YYYY HH:mm:ss") }</td>
												<td>
												{dado.status == '1' ? <span style={{color: 'green', fontWeight: 'bold'}}>PAGO</span> : ''}
												{dado.status == '2' ? <span style={{color: 'orange', fontWeight: 'bold'}}>PENDENTE</span> : ''}
													</td>
												<td style={{display: 'flex', justifyContent: 'space-evenly'}}>
												<button type="button" onClick={(e) => handleEditarFatura(e, dado.id)} className='btn btn-secundary' style={{height: '25px', paddingTop: '2px', background: '#3559e4', color: '#fff'}}>Editar</button>
												</td>
											</tr>)
										}) : <></>}
									</tbody>
								</table>

							</div>

							<div class="pagnatin">
								<div class="clearfix"></div>


							</div>
						</div>
						<input type="hidden" value="" name="paginas" id="paginas" />
					</div>
				</div>
			</form></div>

											</div>

											<div role="tabpanel" class={toggleState === 4 ? 'tab-pane active' : 'tab-pane'} id="endereco">
												<form onSubmit={submitEndereco} method="POST">
													<div class="form-row">
													<span style={{fontSize:'0.8rem', display: 'flex', justifyContent:'flex-start', marginLeft: '15px'}}>Localize qualquer pessoa através do endereço.</span>

														<div className="form-group col-md-7">
															<input type="text" className="form-control" id="end_logradouro" name="end_logradouro" placeholder="Logradouro" value={logradouro} onChange={(e) => setLogradouro(e.target.value)} />
														</div>

														<div class="form-group col-md-2">
															<input type="number" class="form-control" id="numero_inicial" name="numero_inicial" placeholder="N.º Inicial" value={numeroInicial} onChange={(e) => setNumeroInicial(e.target.value)} />
														</div>
														<div class="form-group col-md-2">
															<input type="number" class="form-control" id="numero_final" name="numero_final" placeholder="N.º Final" value={numeroFinal} onChange={(e) => setNumeroFinal(e.target.value)} />
														</div>
													</div>
													<div class="form-row">

														<div className="form-group col-md-4">
															<input type="text" className="form-control" id="end_cidade" name="end_cidade" placeholder="Cidade" value={cidade} onChange={(e) => setCidade(e.target.value)} />
														</div>
														<div className="form-group col-md-2">
															<input type="text" className="form-control" id="end_uf" name="end_uf" placeholder="UF" value={uf} onChange={(e) => setUf(e.target.value)} />
														</div>
														<div className="form-group col-md-3" style={{ marginTop: '1px;' }}>
															<button type="submit" className="btn btn-primary bntalt pesquisar" id="pes_end">Pesquisar</button>
														</div>
													</div>
												</form>
											</div>

											
											
											<div role="tabpanel" class={toggleState === 3 ? 'tab-pane active' : 'tab-pane'} id="documento">
												<form onSubmit={submitDoc} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="Pesquisar usuário" name="doc" id="doc" value={doc} onChange={(e) => setDoc(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="button" id="pes_doc" onClick={submitDoc}>
																	<span class="glyphicon glyphicon-search"></span>
																</button>
															</span>

														</div>

													</div>

												</form>


		<div class="container" style={{ marginBottom: '8%;' }}>
			<form style={{ marginTop: '0', paddingTop: '0' }}>
				<div class="col-md-12">

					<div class="tab-content" id="PesquisaResult">
						<div role="tabpanel" class="tab-pane active" id="home">
							<div class="table-responsive">
								<table id="result" class="table table-bordred table-striped">
									<thead>
										<tr>
										<th>ID</th>
											<th>Usuário</th>
											<th>IP</th>
											<th>Navegador</th>
											<th>Data</th>
											<th>OPÇÕES</th>
										</tr>
									</thead>
									<tbody>
										{dadosOnline ? (dadosOnline).map((dado) => {
											
											return (<tr>
												<td><a target='_blank' href={`#`} onClick={() => handleDeslogar(dado.id)}>#{dado.id}</a></td>
												<td>{dado.usuario}</td>
												<td>{dado.ip}</td>
												<td><input type="text" value={dado.navegador}/></td>
												<td>{moment(dado.created_at).format("DD/MM/YYYY HH:mm:ss") }</td>

												<td style={{display: 'flex', justifyContent: 'space-evenly'}}>
												<button onClick={() => handleDeslogar(dado.id)} className='btn btn-secundary' type='buttom' style={{height: '25px', paddingTop: '2px', background: '#3559e4', color: '#fff'}}>Deslogar</button>
												</td>
											</tr>)
										}) : <></>}
									</tbody>
								</table>

							</div>

							<div class="pagnatin">
								<div class="clearfix"></div>


							</div>
						</div>
						<input type="hidden" value="" name="paginas" id="paginas" />
					</div>
				</div>
			</form></div>

											</div>



											<div role="tabpanel" class={toggleState === 5 ? 'tab-pane active' : 'tab-pane'} id="email">
												<form onSubmit={submitEmail} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="algo@hotmail.com" name="n_email" id="n_email" value={email} onChange={(e) => setEmail(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="submit" id="pes_email">
																	<span class=" glyphicon glyphicon-search"></span>
																</button>
															</span>
														</div>
													</div>
													<span style={{fontSize:'0.8rem', display: 'flex', justifyContent:'center'}}>Localize qualquer pessoa através do e-mail.</span>

												</form>
											</div>
											<div role="tabpanel" class={toggleState === 6 ? 'tab-pane active' : 'tab-pane'} id="placa">
												<form onSubmit={submitPlaca} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="Digite a PLACA" name="n_email" id="n_email" value={placa} onChange={(e) => setPlaca(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="submit" id="pes_email">
																	<span class=" glyphicon glyphicon-search"></span>
																</button>
															</span>

														</div>

													</div>

												</form>
											</div>
										</div>
									</div>
								</div>
							</div> : (``)}
							{msg.length > 0 ? <center>{msg}</center> : ''}

							{dados.length > 0 ? <DadosLayout dados={dados} /> : null}
							{dadosPlaca.length > 0 ? '' : <dadosPlaca dadosPlaca={dadosPlaca} />}
							{/* {listaDados.length > 0 ? <dadosLista dados={listaDados}/> : null} */}








						</div>
					</div>
				</div>
			</section>
		</>

	)
}

export default Painel;
